import { useQuery } from "@apollo/client";
import { GET_APPLICATION_REPORT } from "../graphql";
import { GetItApplicationReportData, GetItApplicationReportVars } from "../types";

export const useApplicationReport = (applicationUUID: string, locationUUID?: string) => {
  const { data, loading, error } = useQuery<GetItApplicationReportData, GetItApplicationReportVars>(GET_APPLICATION_REPORT, {
    variables: {
      applicationUUID,
      locationUUID,
    },
  });

  return {
    data: data?.getApplicationReport || null,
    loading,
    error,
  };
};